<template>
  <qc-container title="运费模板">
    <page-request ref="table" :url="urlArr[type]" :table-header="tableHeader" :expend="expend" :search-type="1" :prop="{type:type}" :op-width="200">
      <t-button @click="doEdit()">添加</t-button>
      <template #op="scope">
        <b-button @click="doEdit(scope.row)">编辑</b-button>
        <b-button v-show="scope.row.status===0" @click="updateStatus([scope.row.id],1)">禁用</b-button>
        <b-button v-show="scope.row.status===1" @click="updateStatus([scope.row.id],0)">启用</b-button>
        <b-button @click="doDel(scope.row.id)">删除</b-button>
      </template>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container";
import PageRequest from "/src/components/base/page-request";
import TButton from "/src/components/el/t-button";
import BButton from "/src/components/el/b-button";


export default {
  props:{
    //类型 0线上商品 1租售商品
    type:{
      type:Number,
      default:0
    }
  },
  name: 'freight-list',
  components: {QcContainer, PageRequest, TButton, BButton},
  data() {
    return {
      urlArr:['/api/mgr/business/freight/findByPage','/api/mgr/business/freight/findByStorePage'],
      tableHeader: [
        {prop: "name", label: "模板名称"},

        {label: "类型",renderDraw:row=>{
            return ['自定义运费','固定运费','卖家承担'][row.type];
          },width: 100},
        {label: "状态",renderDraw:row=>{
            return row.status?"禁用":"正常";
          },width: 100},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend: [
        {label: "模板名称", prop: "name"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doEdit(row) {
      this.toRouter("/index/freight/add",{id:row&&row.id,type:this.type})
    },
    doDel(id) {
      this.msgConfirm("/api/mgr/business/freight/delete", {id: id}, () => {
        this.pageReloadData();
      });
    },

    updateStatus(id,status){
      this.msgConfirm("/api/mgr/business/freight/updateStatus",{ids:id,status:status},()=>{
        this.pageReloadData();
      },`您是否要${status?'禁用':'启用'}所选模板?`)
    },

  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>

</style>
